import { render, staticRenderFns } from "./SupplierModal.vue?vue&type=template&id=36698a4a&"
import script from "./SupplierModal.vue?vue&type=script&lang=js&"
export * from "./SupplierModal.vue?vue&type=script&lang=js&"
import style0 from "./SupplierModal.vue?vue&type=style&index=0&id=36698a4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports